import React, { useState, useRef, useEffect } from 'react';
import { Globe, Check, ChevronDown } from 'lucide-react';
import { useLang } from '../App';
import { LANGUAGES } from '../i18n/config';

export const LanguageSelector = ({ tone = 'muted', testId = 'language-selector' }) => {
  const { lang, setLanguage } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];
  const triggerColor = tone === 'light' ? { color: 'rgba(255,255,255,0.85)' } : { color: 'var(--idfc-text-muted)' };

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        data-testid={testId}
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-1.5 text-xs font-mono px-2 py-1 rounded-md hover:bg-black/5 transition-colors"
        style={triggerColor}
        aria-label="Select language"
      >
        <span className="text-sm leading-none">{current.flag}</span>
        <span>{current.code.toUpperCase()}</span>
        <ChevronDown className="w-3 h-3 opacity-70" />
      </button>
      {open && (
        <div
          className="absolute right-0 mt-2 w-44 rounded-xl border border-slate-200 bg-white shadow-xl z-[60] py-1.5 overflow-hidden"
          data-testid="language-menu"
        >
          {LANGUAGES.filter((l) => l.ready).map((l) => (
            <button
              key={l.code}
              type="button"
              data-testid={`lang-option-${l.code}`}
              onClick={() => { setLanguage(l.code); setOpen(false); }}
              className="w-full flex items-center justify-between px-3.5 py-2 text-sm text-slate-700 hover:bg-slate-100 transition-colors text-left"
            >
              <span className="flex items-center gap-2.5">
                <span className="text-base leading-none">{l.flag}</span>
                <span>{l.native}</span>
              </span>
              {l.code === lang && <Check className="w-3.5 h-3.5 text-[#45B08F]" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
